export const URL_PREFIX = '/api/'